import { FC, InputHTMLAttributes, useId } from 'react'
import { useTheme } from 'styled-components'

import { Icons } from '../../../components/Icon'

import * as SC from './styled'

export type FormFieldCheckboxProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value'
> & {
  className?: string
  name: string
  checked?: boolean
  value?: string | number
  label?: string
  required?: boolean
  disabled?: boolean
  error?: string
  hasError?: boolean
  help?: string
  isGroupChild?: boolean
}

const FormFieldCheckbox: FC<FormFieldCheckboxProps> = ({
  className,
  label,
  error,
  hasError,
  help,
  isGroupChild,
  ...inputProps
}) => {
  const localId = useId()
  const theme = useTheme()

  return (
    <SC.Container className={className} $isDisabled={!!inputProps.disabled}>
      <SC.Label $isDisabled={!!inputProps.disabled} id={localId}>
        <SC.Box>
          <SC.Checkbox
            {...inputProps}
            id={localId}
            type="checkbox"
            $isError={isGroupChild ? false : !!error || hasError}
          />
          <SC.StyledIcon
            icon={
              inputProps.checked ? Icons.checkboxFilled : Icons.checkboxDefault
            }
            color={
              (isGroupChild ? false : !!error || hasError)
                ? theme.colors.bordeaux
                : theme.colors.black
            }
            width={25}
          />
        </SC.Box>

        <SC.LabelText
          $required={!!inputProps.required}
          $isError={isGroupChild ? false : !!error || hasError}
          dangerouslySetInnerHTML={{ __html: label ?? '' }}
        />
      </SC.Label>
      {!error && help && <SC.Help>{help}</SC.Help>}
      {error && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormFieldCheckbox
